// ==============================|| OVERRIDES - TABLE ROW ||============================== //

export default function TableRow() {
  return {
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:last-of-type': {
            '& .MuiTableCell-root': {
              borderBottom: 'none',
            }
          },
          '& .MuiTableCell-root': {
            padding: 4,
            '&:last-of-type': {
              paddingRight: 8
            },
            '&:first-of-type': {
              paddingLeft: 8
            }
          }
        }
      }
    }
  };
}
